export enum ProviderState {
  Enabled = "Enabled",
  Disabled = "Disabled",
}

export enum ProviderType {
  LocalPayment = "LocalPayment",
  Gateway = "Gateway",
}

export enum ProviderCode {
  LocalPayment = "LocalPayment",
  Pagaleve = "Pagaleve",
}

export enum PaymentMethod {
  Credit = "Credit",
  Debit = "Debit",
  Pix = "Pix",
  Cash = "Cash",
  Dinheiro = "Dinheiro",
  PixParcelado = "PixParcelado",
}

export enum CardBrand {
  Mastercard = "Mastercard",
  Visa = "Visa",
  Hipercard = "Hipercard",
  Elo = "Elo",
  Amex = "Amex",
}

export enum MethodId {
  Credit = "credit",
  Debit = "debit",
  Pix = "pix",
  Dinheiro = "dinheiro",
}
